// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__3PvPc","plane":"Layout_plane__2P09i","planeBg":"Layout_planeBg__2IAFG","earth":"Layout_earth__928AC"};